/* api.jquery.js */
function floatToString(t,r){var e=t.toFixed(r).toString();return e.match(/^\.\d+/)?"0"+e:e}function attributeToString(t){return"string"!=typeof t&&"undefined"===(t+="")&&(t=""),jQuery.trim(t)}"undefined"==typeof window.Shopify&&(window.Shopify={}),Shopify.money_format="${{amount}}",Shopify.onError=function(t,r){var e=eval("("+t.responseText+")");e.message?alert(e.message+"("+e.status+"): "+e.description):alert("Error : "+Shopify.fullMessagesFromErrors(e).join("; ")+".")},Shopify.fullMessagesFromErrors=function(t){var o=[];return jQuery.each(t,function(e,t){jQuery.each(t,function(t,r){o.push(e+" "+r)})}),o},Shopify.onCartUpdate=function(t){alert("There are now "+t.item_count+" items in the cart.")},Shopify.onCartShippingRatesUpdate=function(t,r){var e="";r.zip&&(e+=r.zip+", "),r.province&&(e+=r.province+", "),e+=r.country,alert("There are "+t.length+" shipping rates available for "+e+", starting at "+Shopify.formatMoney(t[0].price)+".")},Shopify.onItemAdded=function(t){alert(t.title+" was added to your shopping cart.")},Shopify.onProduct=function(t){alert("Received everything we ever wanted to know about "+t.title)},Shopify.formatMoney=function(t,r){function n(t,r){return void 0===t?r:t}function e(t,r,e,o){if(r=n(r,2),e=n(e,","),o=n(o,"."),isNaN(t)||null==t)return 0;var a=(t=(t/100).toFixed(r)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?o+a[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",a=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(a)[1]){case"amount":o=e(t,2);break;case"amount_no_decimals":o=e(t,0);break;case"amount_with_comma_separator":o=e(t,2,".",",");break;case"amount_with_space_separator":o=e(t,2," ",",");break;case"amount_with_period_and_space_separator":o=e(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=e(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=e(t,0,".","");break;case"amount_with_space_separator":o=e(t,2,",","");break;case"amount_with_apostrophe_separator":o=e(t,2,"'",".")}return i.replace(a,o)},Shopify.resizeImage=function(t,r){try{if("original"==r)return t;var e=t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);return e[1]+"_"+r+"."+e[2]}catch(o){return t}},Shopify.addItem=function(t,r,e){var o={type:"POST",url:"/cart/add.js",data:"quantity="+(r=r||1)+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.addItemFromForm=function(t,r){var e={type:"POST",url:"/cart/add.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onItemAdded(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.getCart=function(r){jQuery.getJSON("/cart.js",function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)})},Shopify.pollForCartShippingRatesForDestination=function(o,a,t){t=t||Shopify.onError;var n=function(){jQuery.ajax("/cart/async_shipping_rates",{dataType:"json",success:function(t,r,e){200===e.status?"function"==typeof a?a(t.shipping_rates,o):Shopify.onCartShippingRatesUpdate(t.shipping_rates,o):setTimeout(n,500)},error:t})};return n},Shopify.getCartShippingRatesForDestination=function(t,r,e){e=e||Shopify.onError;var o={type:"POST",url:"/cart/prepare_shipping_rates",data:Shopify.param({shipping_address:t}),success:Shopify.pollForCartShippingRatesForDestination(t,r,e),error:e};jQuery.ajax(o)},Shopify.getProduct=function(t,r){jQuery.getJSON("/products/"+t+".js",function(t){"function"==typeof r?r(t):Shopify.onProduct(t)})},Shopify.changeItem=function(t,r,e){var o={type:"POST",url:"/cart/change.js",data:"quantity="+r+"&id="+t,dataType:"json",success:function(t){"function"==typeof e?e(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(o)},Shopify.removeItem=function(t,r){var e={type:"POST",url:"/cart/change.js",data:"quantity=0&id="+t,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.clear=function(r){var t={type:"POST",url:"/cart/clear.js",data:"",dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(t)},Shopify.updateCartFromForm=function(t,r){var e={type:"POST",url:"/cart/update.js",data:jQuery("#"+t).serialize(),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartAttributes=function(t,r){var o="";jQuery.isArray(t)?jQuery.each(t,function(t,r){var e=attributeToString(r.key);""!==e&&(o+="attributes["+e+"]="+attributeToString(r.value)+"&")}):"object"==typeof t&&null!==t&&jQuery.each(t,function(t,r){o+="attributes["+attributeToString(t)+"]="+attributeToString(r)+"&"});var e={type:"POST",url:"/cart/update.js",data:o,dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},Shopify.updateCartNote=function(t,r){var e={type:"POST",url:"/cart/update.js",data:"note="+attributeToString(t),dataType:"json",success:function(t){"function"==typeof r?r(t):Shopify.onCartUpdate(t)},error:function(t,r){Shopify.onError(t,r)}};jQuery.ajax(e)},"1.4"<=jQuery.fn.jquery?Shopify.param=jQuery.param:(Shopify.param=function(t){var e=[],r=function(t,r){r=jQuery.isFunction(r)?r():r,e[e.length]=encodeURIComponent(t)+"="+encodeURIComponent(r)};if(jQuery.isArray(t)||t.jquery)jQuery.each(t,function(){r(this.name,this.value)});else for(var o in t)Shopify.buildParams(o,t[o],r);return e.join("&").replace(/%20/g,"+")},Shopify.buildParams=function(e,t,o){jQuery.isArray(t)&&t.length?jQuery.each(t,function(t,r){rbracket.test(e)?o(e,r):Shopify.buildParams(e+"["+("object"==typeof r||jQuery.isArray(r)?t:"")+"]",r,o)}):null!=t&&"object"==typeof t?Shopify.isEmptyObject(t)?o(e,""):jQuery.each(t,function(t,r){Shopify.buildParams(e+"["+t+"]",r,o)}):o(e,t)},Shopify.isEmptyObject=function(t){for(var r in t)return!1;return!0});
/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,checkVisibility:!0,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",slideTransition:"",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g>0;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i,g-=1;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.$stage.children(".center").removeClass("center"),this.settings.center&&this.$stage.children().eq(this.current()).addClass("center")}}],e.prototype.initializeStage=function(){this.$stage=this.$element.find("."+this.settings.stageClass),this.$stage.length||(this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+">",{class:this.settings.stageClass}).wrap(a("<div/>",{class:this.settings.stageOuterClass})),this.$element.append(this.$stage.parent()))},e.prototype.initializeItems=function(){var b=this.$element.find(".owl-item");if(b.length)return this._items=b.get().map(function(b){return a(b)}),this._mergers=this._items.map(function(){return 1}),void this.refresh();this.replace(this.$element.children().not(this.$stage.parent())),this.isVisible()?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)},e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var a,b,c;a=this.$element.find("img"),b=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,c=this.$element.children(b).width(),a.length&&c<=0&&this.preloadAutoWidthImages(a)}this.initializeStage(),this.initializeItems(),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.isVisible=function(){return!this.settings.checkVisibility||this.$element.is(":visible")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.isVisible()&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),!1!==this.settings.responsive&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var e=-1,f=30,g=this.width(),h=this.coordinates();return this.settings.freeDrag||a.each(h,a.proxy(function(a,i){return"left"===c&&b>i-f&&b<i+f?e=a:"right"===c&&b>i-g-f&&b<i-g+f?e=a+1:this.op(b,"<",i)&&this.op(b,">",h[a+1]!==d?h[a+1]:i-g)&&(e="left"===c?a+1:a),-1===e},this)),this.settings.loop||(this.op(b,">",h[this.minimum()])?e=b=this.minimum():this.op(b,"<",h[this.maximum()])&&(e=b=this.maximum())),e},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"+(this.settings.slideTransition?" "+this.settings.slideTransition:"")}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){(a=this.normalize(a))!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){if(b=this._items.length)for(c=this._items[--b].width(),d=this.$element.width();b--&&!((c+=this._items[b].width()+this.settings.margin)>d););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2==0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=-1*f*g),a=c+e,(d=((a-h)%g+g)%g+h)!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.isVisible()&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){(a=this.normalize(a,!0))!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),!1!==this.settings.responsive&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.remove(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&-1!==a.namespace.indexOf("owl")?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.isVisible(),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.isVisible()!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type)){var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&-1*e||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);for(c.lazyLoadEager>0&&(e+=c.lazyLoadEager,c.loop&&(g-=c.lazyLoadEager,e++));f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1,lazyLoadEager:0},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src")||f.attr("data-srcset");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):f.is("source")?f.one("load.owl.lazy",a.proxy(function(){this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("srcset",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(c){this._core=c,this._previousHeight=null,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"===a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._intervalId=null;var d=this;a(b).on("load",function(){d._core.settings.autoHeight&&d.update()}),a(b).resize(function(){d._core.settings.autoHeight&&(null!=d._intervalId&&clearTimeout(d._intervalId),d._intervalId=setTimeout(function(){d.update()},250))})};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.settings.lazyLoad,e=this._core.$stage.children().toArray().slice(b,c),f=[],g=0;a.each(e,function(b,c){f.push(a(c).height())}),g=Math.max.apply(null,f),g<=1&&d&&this._previousHeight&&(g=this._previousHeight),this._previousHeight=g,this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?"width:"+c.width+"px;height:"+c.height+"px;":"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(c){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?a("<div/>",{class:"owl-video-tn "+j,srcType:c}):a("<div/>",{class:"owl-video-tn",style:"opacity:1;background-image:url("+c+")"}),b.after(d),b.after(e)};if(b.wrap(a("<div/>",{class:"owl-video-wrapper",style:g})),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),c=a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),c.attr("height",h),c.attr("width",g),"youtube"===f.type?c.attr("src","//www.youtube.com/embed/"+f.id+"?autoplay=1&rel=0&v="+f.id):"vimeo"===f.type?c.attr("src","//player.vimeo.com/video/"+f.id+"?autoplay=1"):"vzaar"===f.type&&c.attr("src","//view.vzaar.com/"+f.id+"/player?autoplay=true"),a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,
animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._call=null,this._time=0,this._timeout=0,this._paused=!0,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._paused&&(this._time=0)},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype._next=function(d){this._call=b.setTimeout(a.proxy(this._next,this,d),this._timeout*(Math.round(this.read()/this._timeout)+1)-this.read()),this._core.is("interacting")||c.hidden||this._core.next(d||this._core.settings.autoplaySpeed)},e.prototype.read=function(){return(new Date).getTime()-this._time},e.prototype.play=function(c,d){var e;this._core.is("rotating")||this._core.enter("rotating"),c=c||this._core.settings.autoplayTimeout,e=Math.min(this._time%(this._timeout||c),c),this._paused?(this._time=this.read(),this._paused=!1):b.clearTimeout(this._call),this._time+=this.read()%c-e,this._timeout=c,this._call=b.setTimeout(a.proxy(this._next,this,d),c-e)},e.prototype.stop=function(){this._core.is("rotating")&&(this._time=0,this._paused=!0,b.clearTimeout(this._call),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&!this._paused&&(this._time=this.read(),this._paused=!0,b.clearTimeout(this._call))},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:['<span>&#x2039;</span>','<span>&#x203a;</span>'],navSpeed:!1,navElement:'button type="button" role="presentation"',navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","button",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d,e;e=this._core.settings;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)"$relative"===b&&e.navContainer?this._controls[b].html(""):this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);
// Easing
var baseEasings = {};
$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
    baseEasings[ name ] = function( p ) {
        return Math.pow( p, i + 2 );
    }
})
$.extend( baseEasings, {
    Sine: function( p ) {
        return 1 - Math.cos( p * Math.PI / 2 );
    },
    Circ: function( p ) {
        return 1 - Math.sqrt( 1 - p * p );
    },
    Elastic: function( p ) {
        return p === 0 || p === 1 ? p :
            -Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
    },
    Back: function( p ) {
        return p * p * ( 3 * p - 2 );
    },
    Bounce: function( p ) {
        var pow2,
            bounce = 4;

        while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
        return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
    }
});
$.each( baseEasings, function( name, easeIn ) {
    $.easing[ "easeIn" + name ] = easeIn;
    $.easing[ "easeOut" + name ] = function( p ) {
        return 1 - easeIn( 1 - p );
    };
    $.easing[ "easeInOut" + name ] = function( p ) {
        return p < 0.5 ?
            easeIn( p * 2 ) / 2 :
            1 - easeIn( p * -2 + 2 ) / 2;
    }
})

var effect = $.effects;

$.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
}

function json_escape(str) {
    return str.replaceAll(/"/g, '\\"').replaceAll(/\n/g, ' ');
}

function pdp_qty_inc(form) {
    var qty_current = pdp_qty_validate($(form).find('[data-pdp-qty]').val(), $(form).find('[data-pdp-qty]'));
    var qty_new = pdp_qty_validate((qty_current + 1), $(form).find('[data-pdp-qty]'));
    $(form).find('[data-pdp-qty]').val(qty_new);
}
function pdp_afterpay_render_show(form) {
    $(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
    $(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
}

function pdp_afterpay_render_invisible(form) {
    $(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
    $(form).find('[data-pdp-afterpay-duplicate]').css('visibility', 'hidden');
}

function pdp_afterpay_render_hide(form) {
    $(form).find('[data-pdp-afterpay-duplicate]').css('display', 'none');
    $(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
}

function pdp_afterpay_render_invisible_TEMP(form) {
    $(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
    $(form).find('[data-pdp-afterpay-duplicate]').css('visibility', 'hidden');
}

function pdp_afterpay_render_hide_TEMP(form) {
    $(form).find('[data-pdp-afterpay-duplicate]').css('display', 'none');
    $(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
}

function pdp_afterpay_render(form) {
    if($(form).find('[data-offers-afterpay]').length > 0) {
        var variant = $(form).data('selected-variant');
        // if selected variant is available...
        if(variant.available) {
            // if has subscription...
            if($(form).find('[data-pdp-offers-subscription]').val() == 'true') {
                // Only hide Afterpay when subscription is explicitly selected.
                // When no [data-purchase-type] radios exist (Recharge app block),
                // val() returns undefined — treat that as one-time and show.
                if($(form).find('[data-purchase-type]:checked').val() == 'subsave') {
                    // make Afterpay message invisible (maintain vertical height)
                    pdp_afterpay_render_invisible(form);
                }
                else {
                    // show Afterpay message text...
                    pdp_afterpay_render_show(form);
                }
            }
            // if does not have subscription...
            else {
                // show Afterpay message text...
                pdp_afterpay_render_show(form);
            }
        }
        // if selected variant is unavailable...
        else {
            // hide Afterpay message altogether (shrink vertical height)
            pdp_afterpay_render_hide(form);
        }
    }
}

function pdp_afterpay_render_show_TEMP(form) {
    $(form).find('[data-pdp-afterpay-duplicate]').css('display', '');
    $(form).find('[data-pdp-afterpay-duplicate]').css('visibility', '');
}
function pdp_atc_mimic(product_id, subx, atc_source_placement) {
    if(typeof subx == 'undefined') {
        subx = false;
    }
    var source_placement = false;
    if(atc_source_placement != '') {
        source_placement = atc_source_placement;
    }
    // if product is in stock
    if($('#product_form_' + product_id).find('.product-form--atc').hasClass('active')) {
        // if any gateway restrictions are present and not passed
        if(
            $('#product_form_' + product_id).hasClass('zipcodegateway')
            ||
            $('#product_form_' + product_id).hasClass('agegateway')
        ) {
            // scroll to pdp form
            $(window).scrollTo($('#product_form_' + product_id), 250, 'easeOutQuad');
            // if zipcode gateway form present
            if($('#product_form_' + product_id).hasClass('zipcodegateway')) {
                // focus in zipcode gateway form field
                $('#product_form_' + product_id).find('[name="zipcode"]').select();
            }
        }
        // if all gateway restrictions are passed (or none are present)
        else {
            // if has subscription
            if(subx) {
                if(subx == 'onetime') {
                    // if subx onetime: check onetime radio button
                    $('#product_form_' + product_id).find('[data-purchase-type-onetime]').prop('checked', true).trigger('onchange');
                }
                else {
                    // if subx recurring: check recurring radio button
                    $('#product_form_' + product_id).find('[data-purchase-type-recurring]').prop('checked', true).trigger('onchange');
                }
            }
            // if has source placement value
            if(source_placement) {
                if(!$('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]').hasClass('revised')) {
                    // set add to cart source placement attribution line item property value
                    $('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]').val(source_placement);
                }
            }
            // trigger form submit
            console.log( `pdp_ajax_atc() > $('#product_form_' + product_id)`, $('#product_form_' + product_id) );
            pdp_ajax_atc($('#product_form_' + product_id));
        }
    }
    // if product is out of stock
    else {
        // scroll to pdp form
        $(window).scrollTo($('#product_form_' + product_id), 250, 'easeOutQuad');
    }
}

function pdp_select_variant_set(form, variant) {

    // get all variants

    var all_variants = false;

    if($(form).find('[data-variant-map]').length > 0) {
        all_variants = JSON.parse($(form).find('[data-variant-map]').html());
        // console.log( `~~ all_variants`, all_variants );
    }
    
    // set variant as active
    $(form).data('selected-variant', variant);
    
    // if available
    if(variant.available) {
        // enable qty & atc btn
        if(!$(form).find('.product-form--qty').hasClass('active')) {
            $(form).find('.product-form--qty').addClass('active');
        }
        if(!$(form).find('.product-form--atc').hasClass('active')) {
            $(form).find('.product-form--atc').addClass('active');
        }
        var $calLabel = $(form).find('.atc-label-1');
        if($calLabel.length) {
            var $atcBtn = $(form).find('[data-pdp-atc]');
            var isOnetime = $(form).find('[data-purchase-type]:checked').val() == 'onetime';
            var labelKey = (!isOnetime && $atcBtn.data('label-subx')) ? 'label-subx' : 'label-default';
            $calLabel.text($atcBtn.data(labelKey));
        }
    }
    else {
        // disable qty & atc btn
        if($(form).find('.product-form--qty').hasClass('active')) {
            $(form).find('.product-form--qty').removeClass('active');
        }
        if($(form).find('.product-form--atc').hasClass('active')) {
            $(form).find('.product-form--atc').removeClass('active');
        }
        var $calLabelOos = $(form).find('.atc-label-1');
        if($calLabelOos.length) {
            $calLabelOos.text($calLabelOos.attr('data-label-out'));
        }
    }

    pdp_afterpay_render(form);
    
    // set `id` : original product variant ID
    $(form).find('[name="id"]').val(variant.variant_id);
    // if product has subscription
    if($(form).find('[name="offers-subscription"]').val() == "true") {
        // if customer has selected subscription option
        if($(form).find('[data-purchase-type]:checked').val() == "autodeliver") {
            // (if JSON is valid)
            if(variant.hasOwnProperty('subx_variant_id')) {
                if(variant.subx_variant_id != null && variant.subx_variant_id != "") {
                    // set `id` : subx product variant ID
                    $(form).find('[name="id"]').val(variant.subx_variant_id);
                }
            }
        }
    }
        
    // price actual
    $(form).find('[data-pdp-form-price-actual]').text(variant.price_money);
    $(form).find('[data-pdp-form-subx-onetime-price-actual]').text(variant.price_money);
    
    // compare at price
    $(form).find('[data-pdp-form-price-compareat]').text(variant.compare_at_money);
    $(form).find('[data-pdp-form-subx-onetime-price-compareat]').text(variant.compare_at_money);
    
    // subx price
    $(form).find('[data-pdp-form-subx-recurring-price-actual]').text(variant.subx_price_money);
    $(form).find('[data-pdp-form-subx-recurring-price-compareat]').text(variant.subx_compare_at_money);
    
    // sticky CTA buttons price
    if($('#pdp-stickycta').length > 0) {

        $('#pdp-stickycta').find('[data-pdp-form-price-actual]').text(variant.price_money);
        $('#pdp-stickycta').find('[data-pdp-form-subx-onetime-price-actual]').text(variant.price_money);

        $('#pdp-stickycta').find('[data-pdp-form-price-compareat]').text(variant.compare_at_money);
        $('#pdp-stickycta').find('[data-pdp-form-subx-onetime-price-compareat]').text(variant.compare_at_money);

        $('#pdp-stickycta').find('[data-pdp-form-subx-recurring-price-actual]').text(variant.subx_price_money);
        $('#pdp-stickycta').find('[data-pdp-form-subx-recurring-price-compareat]').text(variant.subx_compare_at_money);
    }

    // if onetime
    if($(form).find('[data-purchase-type]:checked').val() == 'onetime') {
        $('[data-atc-mimic]').find('.active-pay-price').text(variant.price_money);
        if(variant.price < variant.compare_at) {
            $('[data-atc-mimic]').find('.active-crossout-price').text(variant.compare_at_money);
        }
        else {
            $('[data-atc-mimic]').find('.active-crossout-price').text('');
        }
        // set Klaviyo metric prices
        $(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-price', variant.price_money);
        $(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-compare-at-price', variant.compare_at_money);
    }
    // if recurring
    else {
        $('[data-atc-mimic]').find('.active-pay-price').text(variant.subx_price_money);
        if(variant.subx_price < variant.subx_compare_at) {
            $('[data-atc-mimic]').find('.active-crossout-price').text(variant.subx_compare_at_money);
        }
        else {
            $('[data-atc-mimic]').find('.active-crossout-price').text('');
        }
        // set Klaviyo metric prices
        $(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-price', variant.subx_price_money);
        $(form).find('[data-klaviyo-product-info]').data('klaviyo-product-info-compare-at-price', variant.subx_compare_at_money);
    }
    
    // price afterpay
    $(form).find('[data-pdp-form-price-afterpay]').text(variant.price_afterpay_money);
    
    $(form).find('.afterpay-container').removeClass('active');
    // if variant price >= $35
    if(variant.price >= 3500) {
        // show container: afterpay eligible
        $(form).find('.afterpay-eligible').addClass('active');
    }
    else {
        // show container: afterpay ineligible
        $(form).find('.afterpay-ineligible').addClass('active');
    }
    
    // membership faux option
    if($(form).find('[data-membership-faux-variant-map]').length > 0) {
        var membership_faux_data = $(form).find('[data-membership-faux-variant-map]').data('membership-faux-variant-map');
        console.log(membership_faux_data);
        for(var mfd_variant_id in membership_faux_data) {
            if(mfd_variant_id == variant.variant_id) {
                $('.membership-faux-memberprice').html(membership_faux_data[mfd_variant_id].memberprice);
                $('.membership-faux-crossoutprice').html(membership_faux_data[mfd_variant_id].crossoutprice);
            }
        }
    }

}
// ------------------------------
// 1️⃣ Sync thumbnail selection
// ------------------------------
function syncThumbnailSelection(mainSlideIndex) {
  const $visibleThumbs = $('.slider-thumbnail .slider-thumbnail__slide:not(.slick-cloned)')
    .filter(function() {
      return $(this).css('display') !== 'none';
    });
  
  // Remove active class from all and reset opacity
  $('.slider-thumbnail .slider-thumbnail__slide')
    .removeClass('slick-current')
    .css('opacity', ''); // Clear inline opacity
  
  // Add active class and force opacity immediately
  $visibleThumbs.eq(mainSlideIndex)
    .addClass('slick-current')
    .css('opacity', '1'); // Force opacity immediately
}

// ------------------------------
// 2️⃣ Show variant images & sync thumbnails
// ------------------------------
function showVariantImages(selectedAlt, allVariantTitles) {
  const mainSliders = $('.productSwiper, .productSwiperMobile');
  const thumbSlider = $('.slider-thumbnail');

  // Filter slides
  function filterFn(index, slide) {
    const slideVariant = $(slide).data('variant');
    return slideVariant === selectedAlt || !allVariantTitles.includes(slideVariant);
  }

  // Apply filter to main sliders
  mainSliders.each(function() {
    const slider = $(this);
    if (slider.hasClass('slick-initialized')) {
      slider.slick('slickUnfilter');
      slider.slick('slickFilter', filterFn);
      slider.slick('slickGoTo', 0, true);
      slider.slick('setPosition');
    }
  });

  // Apply filter to thumbnails
  if (thumbSlider.hasClass('slick-initialized')) {
    thumbSlider.slick('slickUnfilter');
    thumbSlider.slick('slickFilter', filterFn);
    thumbSlider.slick('slickGoTo', 0, true);
    thumbSlider.slick('setPosition');
  }

  // Force sync after filtering
  setTimeout(() => {
    syncThumbnailSelection(0);
  }, 50);
}

// ------------------------------
// 3️⃣ Init PDP gallery sliders
// ------------------------------
function initProductSliders() {
  var disableDesktopSlider = $('.productSwiper').attr('data-disable-desktop-slider') === 'true';

  // Main desktop gallery
  if (!disableDesktopSlider && $('.productSwiper').length && !$('.productSwiper').hasClass('slick-initialized')) {
    $('.productSwiper').slick({
      autoplay: false,
      slidesToShow: 1,
      arrows: true,
      fade: true,
      dots: false,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next')
    });

    $('.productSwiper').on('afterChange', function(event, slick, currentSlide) {
      syncThumbnailSelection(currentSlide);
      $(this).find('video').each(function() { this.pause(); });
      var video = $(slick.$slides[currentSlide]).find('video')[0];
      if (video) video.play();
    });
  }

    // Thumbnails (also skip init when desktop slider is disabled)
    if (!disableDesktopSlider && $('.slider-thumbnail').length && !$('.slider-thumbnail').hasClass('slick-initialized')) {
    $('.slider-thumbnail').slick({
        autoplay: false,
        dots: false,
        centerMode: false,
        focusOnSelect: false,
        slidesToShow: "auto",
        slidesToScroll: 1
    });
    
    $('.slider-thumbnail').on('click', '.slider-thumbnail__slide', function() {
        // ✅ Immediately update active states (no delay)
        $('.slider-thumbnail .slider-thumbnail__slide').removeClass('slick-current');
        $(this).addClass('slick-current');
        
        // Then handle the main slider navigation
        const $visibleThumbs = $('.slider-thumbnail .slider-thumbnail__slide:not(.slick-cloned)')
        .filter(function() {
            return $(this).css('display') !== 'none';
        });
        
        const visibleIndex = $visibleThumbs.index($(this));
        
        if (visibleIndex >= 0) {
        $('.productSwiper').slick('slickGoTo', visibleIndex, false);
        }
    });
    }

  // Mobile gallery
  if ($('.productSwiperMobile').length && !$('.productSwiperMobile').hasClass('slick-initialized')) {
    var $mobileGallery = $('.productSwiperMobile');
    var isAlternativeStyle = $mobileGallery.data('alternative-style') === true || $mobileGallery.attr('data-alternative-style') === 'true';
    var disableCenter = $mobileGallery.attr('data-disable-center') === 'true';
    var slideCount = $mobileGallery.find('.productSwiperMobile-slide').length;
    var slickOpts = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      swipe: true,
      arrows: false,
      focusOnSelect: true
    };
    if (disableCenter) {
      slickOpts.centerMode = false;
      slickOpts.variableWidth = true;
      slickOpts.dots = true;
    } else if (isAlternativeStyle) {
      slickOpts.centerMode = true;
      slickOpts.centerPadding = '14px';
      slickOpts.dots = false;
    } else {
      slickOpts.centerMode = true;
      slickOpts.centerPadding = '20%';
      slickOpts.dots = true;
    }
    if (slideCount <= 1) {
      slickOpts.centerMode = true;
      slickOpts.centerPadding = '15px';
      slickOpts.dots = false;
    }
    $mobileGallery.slick(slickOpts);
    $mobileGallery.on('afterChange', function(event, slick, currentSlide) {
      $(this).find('video').each(function() { this.pause(); });
      var video = $(slick.$slides[currentSlide]).find('video')[0];
      if (video) video.play();
    });
  }
}

jQuery(document).ready(function($) {
  initProductSliders();
});

// ------------------------------
// 5️⃣ Variant selection handler
// ------------------------------
window.pdp_select_variant = function(form) {
  const pdp_variant_map = JSON.parse($(form).find('[data-variant-map]').html());
  const options = $(form).data('options').split(',');

  const allVariantTitles = pdp_variant_map.map(v => v.option1);
  let selectedVariant = null;

  if (pdp_variant_map.length > 1) {
    const optionValues = {};
    options.forEach((opt, i) => {
      optionValues['option' + (i + 1)] = $(form).find('[name="' + opt + '"]:checked').val();
    });

    selectedVariant = pdp_variant_map.find(variant => {
      return Object.keys(optionValues).every(key => variant[key] === optionValues[key]);
    });
  } else {
    selectedVariant = pdp_variant_map[0];
  }

  if (selectedVariant) {
    pdp_select_variant_set(form, selectedVariant);
    pdp_set_subscriptionoption_prop(form, selectedVariant);
    showVariantImages(selectedVariant.option1, allVariantTitles);
  }
};

function pdp_subx_option(form) {
    var atc = $(form).find('[data-pdp-atc]');
    var calendarAtc = atc.attr('data-calendar-enabled') === 'true';
    var $calLabel = $(form).find('.atc-label-1');
    // IF: ONE TIME
    if($(form).find('[data-purchase-type]:checked').val() == 'onetime') {
        // remove [name="selling_plan"] from recurring <select>
        $(form).find('[data-selling-plan]').removeAttr('name');
        // set 'add to cart' button text: default (calendar PDPs use inner .atc-label-1, not button .text())
        if(calendarAtc && $calLabel.length) {
            $calLabel.text(atc.data('label-default'));
        } else {
            atc.text(atc.data('label-default'));
        }
        // mark active 'add to cart' button text: default
        atc.data('label-active', 'default');
        // set mimic 'add to cart' button text: default
        $('[data-atc-mimic] > .active-cta').text(atc.data('label-default'));
        // set sticky cta bar buttons (mobile) > onetime
        if($(form).find('#ProductFormMainPlacement').length > 0) {
            $('#pdp-stickycta').find('.pdp-stickycta-buttons').removeClass('recurring');
            if(calendarAtc) {
                // Mobile calendar sticky: update action label span
                $('.calendar-sticky-atc-label-1').text(atc.data('label-default'));
            }
        }
    }
    // IF: RECURRING
    else {
        // add [name="selling_plan"] back to recurring <select>
        $(form).find('[data-selling-plan]').attr('name', 'selling_plan');
        // set 'add to cart' button text: subx
        if(calendarAtc && $calLabel.length) {
            $calLabel.text(atc.data('label-subx'));
        } else {
            atc.text(atc.data('label-subx'));
        }
        // mark active 'add to cart' button text: subx
        atc.data('label-active', 'subx');
        // set mimic 'add to cart' button text: default
        $('[data-atc-mimic] > .active-cta').text(atc.data('label-subx'));
        // set sticky cta bar buttons (mobile) > onetime
        if($(form).find('#ProductFormMainPlacement').length > 0) {
            $('#pdp-stickycta').find('.pdp-stickycta-buttons').addClass('recurring');
            if(calendarAtc) {
                // Mobile calendar sticky: update action label span
                $('.calendar-sticky-atc-label-1').text(atc.data('label-subx'));
            }
        }
    }
    console.log(
        'pdp_subx_option()',
        $(form).find('[data-purchase-type]:checked').val(),
        ($(form).find('[name="selling_plan"]').length > 0) ? $(form).find('[name="selling_plan"]').val() : ''
    );
    // set variant ID
    pdp_select_variant(form);
}

function pdp_set_subscriptionoption_prop(form, variant) {
    $(form).find('[data-subscriptionoption]').attr('name', '');
    $(form).find('[data-subscriptionoptionvariantid="' + variant.variant_id + '"]').attr('name', 'properties[_subscriptionOption]');
}

function screendm_megamenu() {
    if($(window).outerWidth() >= 1000) {
        return 'desktop';
    }
    else {
        return 'mobile';
    }
}

function cookiesParse(c) {
    if(typeof c == 'undefined') {
        c = document.cookie;
    }
    var o = {};
    var x = c.split('; ');
    for(var iA = 0; iA < x.length; iA++) {
        var y = x[iA].trim().split(/=(.+)/);
        o[y[0]] = y[1];
    }
    return o;
}

function cookieSet(key, value, num_days, path, domain) {
    if(typeof path == 'undefined') {
        path = '/';
    }
    if(typeof domain == 'undefined') {
        domain = location.hostname.replace('www.', '');
    }
    if(num_days) {
        var date = new Date();
        date.setTime(date.getTime() + (num_days * 24 * 60 * 60 * 1000));
        var expires = '; expires=' + date.toGMTString();
    }
    else {
        var expires = '';
    }
    document.cookie = key + '=' + value + expires + '; path=' + path + '; domain=' + domain;
}

function cookieGet(key) {
    var keyEQ = key + '=';
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while(c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
            if(c.indexOf(keyEQ) == 0) {
                return c.substring(keyEQ.length, c.length);
            }
        }
    }
    return null;
}

function cookieDelete(key) {
    createCookie(key, '', -1);
}

function cookieEncode(dec) {
    return window.btoa(JSON.stringify(dec));
}

function cookieDecode(enc) {
    try {
        return JSON.parse(window.atob(enc));
    } catch(e) {
        // Cookie is missing, empty, or not valid base64 — return a safe default
        // so callers (zipcode_gateway_render etc.) can treat it as "no cookie set"
        return {};
    }
}

function pdp_ajax_atc(obj) {
    // prevent double submission if button already disabled from first call
    if($(obj).find('[data-pdp-atc]').prop('disabled')) {
        return false;
    }
    // if no gateway restrictions are present...
    if(
        !$(obj).closest('.product-form').hasClass('zipcodegateway')
        &&
        !$(obj).closest('.product-form').hasClass('agegateway')
    ) {
        // ajax add to cart
        pdp_atc(obj);
    }
    // if at least one gateway restriction is present...
    else {
        var gateway_restrictions = [];
        if($(obj).closest('.product-form').hasClass('zipcodegateway')) {
            gateway_restrictions.push('zipcodegateway');
        }
        if($(obj).closest('.product-form').hasClass('agegateway')) {
            gateway_restrictions.push('agegateway');
        }
    }
    return false;
}

function pdp_atc(form) {
    if($(form).hasClass('manual')) {
        return true;
    }
    
    // pause ATC button
    var atc = $(form).find('[data-pdp-atc]');
    var calendarAtc = atc.attr('data-calendar-enabled') === 'true';
    var $calLabel = $(form).find('.atc-label-1');
    atc.prop('disabled', true);
    if(!calendarAtc || !$calLabel.length) {
        atc.text('ADDING...');
    }
    
    // pause mimic ATC buttons
    $('[data-atc-mimic]').prop('disabled', true);
    $('[data-atc-mimic] > .active-cta').text('ADDING...');
    
    var productdata = $(form).serializeObject();

    productdata = Object.entries(productdata).reduce((acc, [key, value]) => {
        const match = key.match(/^properties\[(.+)\]$/);  // FIXED: was \w+ now .+ to allow spaces and special chars
        if (match) {
            acc.properties = acc.properties || {};
            acc.properties[match[1]] = value;
        } else {
            acc[key] = value;
        }
        return acc;
    }, {});
    
    if($(form).find('.product-form--qty--input--field').data('multiplier')) {
        productdata.quantity = parseInt(productdata.quantity) * parseInt($(form).find('.product-form--qty--input--field').data('multiplier'));
    }
    
    var p_atc_source_placement = '';
    var p_atc_source_type = '';
    var p_atc_source_value = '';
    
    if(productdata.hasOwnProperty('properties')) {
        if(productdata.properties.hasOwnProperty('_atc_source_placement')) {
            p_atc_source_placement = productdata.properties['_atc_source_placement'];
        }
        if(productdata.properties.hasOwnProperty('_atc_source_type')) {
            p_atc_source_type = productdata.properties['_atc_source_type'];
        }
        if(productdata.properties.hasOwnProperty('_atc_source_value')) {
            p_atc_source_value = productdata.properties['_atc_source_value'];
        }
    }

    var atcdata = {
        'items': []
    };

    if($(form).find('input[name="addon_paid_pump"]').length > 0) {
        if($(form).find('input[name="addon_paid_pump"]').is(':checked')) {
            var addon_paid_pump_qty_pump = parseInt($(form).find('input[name="addon_paid_pump"]').val());
            var addon_paid_pump_qty_multiplier = parseInt($(form).find('[data-pdp-qty]').val());
            var addon_paid_pump_qty = addon_paid_pump_qty_pump * addon_paid_pump_qty_multiplier;
            atcdata.items.push({
                'id': $(form).find('input[name="addon_paid_pump"]').data('variant-id'),
                'quantity': addon_paid_pump_qty,
                'properties': {
                    '_atc_source_placement': p_atc_source_placement,
                    '_atc_source_type': p_atc_source_type,
                    '_atc_source_value': p_atc_source_value
                }
            });
        }
    }
    
    if($(form).find('input[name="addon_product"]').length > 0) {
        $(form).find('input[name="addon_product"]').each(function() {
            if($(this).is(':checked')) {
                var addon_product_qty = parseInt($(this).val());
                var addon_product_data = {
                    'id': $(form).find('input[name="addon_product"]').data('variant-id'),
                    'quantity': addon_product_qty,
                    'properties': {
                        '_atc_source_placement': p_atc_source_placement,
                        '_atc_source_type': p_atc_source_type,
                        '_atc_source_value': p_atc_source_value
                    }
                };
                if($(this).data('selling-plan')) {
                    addon_product_data.selling_plan = $(this).data('selling-plan');
                }
                atcdata.items.push(addon_product_data);
            }
        });
    }

    // add form product *last*
    atcdata.items.push(productdata);
    
    // bundled section rendering
    var bsr_sections = false;
    if($(form).find('input[name="bsr"]').length > 0) {
        bsr_sections = $(form).find('input[name="bsr"]').val();
    }

    try {
        // AJAX add to cart using fetch
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(atcdata)
        })
        .then(function(response) {
            if (!response.ok) {
                return response.json().then(function(errData) {
                    throw errData;
                });
            }
            return response.json();
        })
        .then(function(r) {
            // success
            console.log('AJAX add to cart success.', r);
            
            // if member + adding free gift, disable button
            if($('#mqg').length > 0) {
                var mqgAtc = $(form).find('[data-pdp-atc]');
                var mqgCal = mqgAtc.attr('data-calendar-enabled') === 'true';
                var mqgLabel = $(form).find('.atc-label-1');
                if(!mqgCal || !mqgLabel.length) {
                    mqgAtc.text('GIFT REDEEMED');
                } else {
                    mqgLabel.text('GIFT REDEEMED');
                }
                mqgAtc.prop('disabled', true);
                $('[data-atc-mimic]').find('.active-cta').text('GIFT REDEEMED');
                $('[data-atc-mimic]').find('.active-price').html('<span class="active-pay-price" data-pdp-form-price-actual>' + $('[data-pdp-form-price-compareat]').data('orig') + '</span>');
                $('[data-atc-mimic]').prop('disabled', true);
                $('[data-atc-mimic-link]').html('<span class="pdp-stickycta-button-text">GIFT REDEEMED</span>');
                $('[data-atc-mimic-link]').removeAttr('onclick');
                $('[data-atc-mimic-link]').addClass('disabled');
            }
            
            // add to cart source attribution
            var product_id = r.items[0].product_id;
            var new_source_type = r.items[0].properties['_atc_source_type'];
            var new_source_value = r.items[0].properties['_atc_source_value'];
            var new_source_placement = r.items[0].properties['_atc_source_placement'];
            $('.product-id-' + product_id + '[name="properties[_atc_source_type]"]').val(new_source_type);
            $('.product-id-' + product_id + '[name="properties[_atc_source_value]"]').val(new_source_value);
            $('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]').val(new_source_placement);
            $('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]').addClass('revised');
            
            if(bsr_sections) {
                bsr(bsr_sections);
            }

            // Rebuy smartcart opens automatically after cart update
        })
        .catch(function(err) {
            // error - display error message if recipient form is present
            console.error('Fetch add to cart error:', err);
            var recipientForm = document.querySelector('recipient-form');
            if (recipientForm && err.description) {
                recipientForm.dispatchEvent(new CustomEvent('cart-error', {
                    detail: { message: err.message, errors: err.description }
                }));
            }
        })
        .finally(function() {
            // resume ATC button
            var resumeAtc = $(form).find('[data-pdp-atc]');
            var resumeCal = resumeAtc.attr('data-calendar-enabled') === 'true';
            var resumeLabel = $(form).find('.atc-label-1');
            var subx = resumeAtc.data('label-active') == 'subx';
            var nextText = subx ? resumeAtc.data('label-subx') : resumeAtc.data('label-default');
            if(resumeCal && resumeLabel.length) {
                resumeLabel.text(nextText);
            } else {
                resumeAtc.text(nextText);
            }
            $('[data-atc-mimic] > .active-cta').text(nextText);
            resumeAtc.prop('disabled', false);
            $('[data-atc-mimic]').prop('disabled', false);
        });
        
        return false;
    }
    catch(err) {
        console.warn('AJAX execution failed. Submitting manually.');
        console.warn(err);
        return true;
    }
}

function to_digits(input, digits, char) {
    char = char || '0';
    input = input + '';
    return input.length >= digits ? input : new Array(digits - input.length + 1).join(char) + input;
}
function pdp_afterpay_popup_open() {
    $('afterpay-modal').attr('visible', 'visible');
}
function pdp_afterpay_popup_close() {
    $('afterpay-modal').removeAttr('visible');
}

function pdp_afterpay_popup_toggle() {
    if(!$('afterpay-modal').attr('visible')) {
        pdp_afterpay_popup_open();
    }
    else {
        pdp_afterpay_popup_close();
    }
}

function pdp_qty_validate(input, field) {
    var qty = parseInt(input);
    if(isNaN(qty)) {
        qty = 1;
    }
    var min = parseInt($(field).attr('min'));
    var max = parseInt($(field).attr('max'));
    if(qty < min) {
        qty = min;
    }
    else if(qty > max) {
        qty = max;
    }
    return qty;
}

function pdp_qty_validate_field(field) {
    var qty = pdp_qty_validate(field.value, field);
    $(field).val(qty);
}

function pdp_qty_dec(form) {
    var qty_current = pdp_qty_validate($(form).find('[data-pdp-qty]').val(), $(form).find('[data-pdp-qty]'));
    var qty_new = pdp_qty_validate((qty_current - 1), $(form).find('[data-pdp-qty]'));
    $(form).find('[data-pdp-qty]').val(qty_new);
}
function strip_zeroes(t) {
    if(t.innerHTML.includes('.00')) {
        t.innerHTML = t.innerHTML.replace('.00', '');
    }
}


// *** PARSE UTM QUERY PARAMS *** //

function getQueryParams(ls) {
    if(typeof ls == 'undefined') {
        var ls = location.search;
    }
    var qp = ls.substring(1).split('&');
    var o = {};
    var x = 0;
    if(ls != '' & qp.length >= 1) {
        for(var i = 0; i < qp.length; i++) {
            qpi = qp[i].split('=');
            o[qpi[0]] = qpi[1];
            x++;
        }
    }
    if(x > 0) {
        return o;
    }
    return false;
}

function legacy_cart_subx(line_item_key, selling_plan_id, original_value, original_type) {
    $legacy_cart_line = $('.CartItem__Subscription .ajax-subx-dd[data-line-item-key="' + line_item_key + '"]');
    var subxOptionStr = $legacy_cart_line.data('subx-option-str');
    // if not already loading
    if(!$legacy_cart_line.hasClass('loading')) {
        // set as loading
        $legacy_cart_line.addClass('loading');
        // AJAX call
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: line_item_key,
                selling_plan: selling_plan_id,
                properties: {
                    '_subscriptionOption': subxOptionStr
                }
            },
            dataType: 'json'
        }).done(function(r) {
            // reload page
            window.location.reload();
        }).fail(function(e) {
            console.warn( 'ERROR', e );
            if(original_type == 'dd') {
                // reset dd value to original value
                $legacy_cart_line.val(original_value);
            }
        }).always(function() {
            // unset loading
            $legacy_cart_line.removeClass('loading');
        });
    }
}


// **************************************************************** //
// *** ALCOHOL AGE CHECK (BLOOM DATE OF BIRTH FORM) *** //
// **************************************************************** //

function padNumber(num, digits) {
    if(typeof digits == 'undefined') {
        digits = 2;
    }
    if(isNaN(num)) {
        return false;
    }
    else {
        var num_abs = Math.abs(num);
        var num_abs_str = num_abs.toString();
        var num_str_output = num_abs_str;
        if(num_abs_str.length < digits) {
            for(var i = 0; i < (digits - num_abs_str.length); i++) {
                num_str_output = '0' + num_str_output;
            }
        }
        if(num < 0) {
            num_str_output = '-' + num_str_output;
        }
        return num_str_output;
    }
}

function setInputFilter(textbox, inputFilter, errMsg) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function(event) {
        textbox.addEventListener(event, function(e) {
            if(inputFilter(this.value)) {
                // Accepted value
                if(["keydown", "mousedown", "focusout"].indexOf(e.type) >= 0) {
                    this.classList.remove("input-error");
                    this.setCustomValidity("");
                }
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            }
            else if(this.hasOwnProperty("oldValue")) {
                // Rejected value - restore the previous one
                this.classList.add("input-error");
                this.setCustomValidity(errMsg);
                this.reportValidity();
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
            else {
                // Rejected value - nothing to restore
                this.value = "";
            }
        })
    })
}

function aac_input_validate(el, field, cart) {
    ["input", "change"].forEach(function(event) {
        el.addEventListener(event, function(e) {
            // disable button
            aac_disable_checkout(this.closest('.aac-cart'), cart);
            // check this input value
            if(!isNaN(parseInt(this.value))) {
                // auto proceed
                if(field == 'm') {
                    if(
                        (parseInt(this.value) > 1)
                        ||
                        (this.value.length == 2)
                    ) {
                        $(this).closest('.aac-cart').find('[data-aac-dob-d]').focus().select();
                    }
                }
                if(field == 'd') {
                    if(this.value.length == 2) {
                        $(this).closest('.aac-cart').find('[data-aac-dob-y]').focus().select();
                    }
                }
                // validate
                var aac_m = false;
                if(!isNaN(parseInt($(this).closest('.aac-cart').find('[data-aac-dob-m]').val()))) {
                    aac_m = $(this).closest('.aac-cart').find('[data-aac-dob-m]').val();
                }
                var aac_d = false;
                if(!isNaN(parseInt($(this).closest('.aac-cart').find('[data-aac-dob-d]').val()))) {
                    aac_d = $(this).closest('.aac-cart').find('[data-aac-dob-d]').val();
                }
                var aac_y = false;
                if(!isNaN(parseInt($(this).closest('.aac-cart').find('[data-aac-dob-y]').val()))) {
                    aac_y = $(this).closest('.aac-cart').find('[data-aac-dob-y]').val();
                }
                if(aac_m && aac_d && aac_y && aac_y.length == 4) {
                    aac_dob_check(aac_m, aac_d, aac_y, this.closest('.aac-cart'), cart);
                }
            }
        });
    });
}

function aac_enable_checkout(form, cart, aac_dob) {
    // set value of Bloom cart attribute
    $(form).find('[data-bloom-dob]').attr('name', 'attributes[Customer date of birth]');
    $(form).find('[data-bloom-dob]').val(aac_dob);
    if(cart == 'legacy') {
        $(form).find('[data-bloom-dob]').attr('form', 'cart-page-form');
    }
    // enable button
    if(cart == 'legacy') {
        $('[data-legacy-cart-checkout-button]').attr('type', 'submit');
        $('[data-legacy-cart-checkout-button]').attr('name', 'checkout');
        $('[data-legacy-cart-checkout-button]').attr('form', 'cart-page-form');
        $('[data-legacy-cart-checkout-button]').prop('disabled', false);
    }
    else if(cart == 'slide') {
        $('#slide-cart-checkout-button').removeClass('disabled');
    }
}

function aac_disable_checkout(form, cart) {
    // disable Bloom cart attribute
    $(form).find('[data-bloom-dob]').removeAttr('name');
    $(form).find('[data-bloom-dob]').val('');
    if(cart == 'legacy') {
        $(form).find('[data-bloom-dob]').removeAttr('form');
    }
    // disable button
    if(cart == 'legacy') {
        $('[data-legacy-cart-checkout-button]').attr('type', 'button');
        $('[data-legacy-cart-checkout-button]').removeAttr('name');
        $('[data-legacy-cart-checkout-button]').removeAttr('form');
        $('[data-legacy-cart-checkout-button]').prop('disabled', true);
    }
    else if(cart == 'slide') {
        $('#slide-cart-checkout-button').addClass('disabled');
    }
}

function aac_dob_check(input_m, input_d, input_y, form, cart) {
    var dob_m = false;
    if(!isNaN(parseInt(input_m))) {
        dob_m = padNumber(input_m, 2);
    }
    var dob_d = false;
    if(!isNaN(parseInt(input_d))) {
        dob_d = padNumber(input_d, 2);
    }
    var dob_y = false;
    if(!isNaN(parseInt(input_y))) {
        dob_y = padNumber(input_y, 4);
    }
    if(dob_m && dob_d && dob_y) {
        // get today's date
        var aac_today_now = new Date();
        var aac_today_now_y = aac_today_now.getFullYear();
        var aac_today_now_m = aac_today_now.getMonth() + 1;
        var aac_today_now_d = aac_today_now.getDate();
        var aac_today = aac_today_now_y + '-' + padNumber(aac_today_now_m, 2) + '-' + padNumber(aac_today_now_d, 2);
        var aac_today_iso = aac_today + 'T00:00:00.000Z';
        var aac_today_date = new Date(aac_today_iso);
        var aac_today_timestamp = Date.parse(aac_today_date);
        // get over 21 date
        var aac_over21 = (aac_today_now_y - 21) + '-' + padNumber(aac_today_now_m, 2) + '-' + padNumber(aac_today_now_d, 2);
        var aac_over21_iso = aac_over21 + 'T00:00:00.000Z';
        var aac_over21_date = new Date(aac_over21_iso);
        var aac_over21_timestamp = Date.parse(aac_over21_date);
        // console.log( `~~~~ ------------------------------` );
        // string input DOB
        var aac_dob = dob_y + '-' + dob_m + '-' + dob_d;
        var aac_dob_iso = aac_dob + 'T00:00:00.000Z';
        var aac_dob_date = new Date(aac_dob_iso);
        var aac_dob_timestamp = Date.parse(aac_dob_date);
        // console.log( `~~~~ ------------------------------` );
        // validate input DOB
        var aac_dob_valid = false;
        if(!isNaN(aac_dob_timestamp)) {
            var aac_dob_check_pieces = aac_dob_date.toISOString();
            var aac_dob_check = aac_dob_check_pieces.split('T')[0];
            if(aac_dob == aac_dob_check) {
                aac_dob_valid = true;
            }
        }
        // check if DOB is over 21
        var aac_is_over21 = false;
        if(aac_dob_valid) {
            if(aac_dob_timestamp <= aac_over21_timestamp) {
                aac_is_over21 = true;
            }
        }
        else {
        }
        // if is over 21
        if(aac_is_over21) {
            // hide error message
            $(form).find('.aac-cart-error').removeClass('on');
            if(cart == 'slide') {
                $('#ajax-cart-form').removeClass('contains-alcohol-error');
                $('#ajax-cart-form').find('.form-b').removeClass('contains-alcohol-error');
            }
            // enable checkout button
            aac_enable_checkout(form, cart, aac_dob);
        }
        // if not over 21
        else {
            // show error message
            $(form).find('.aac-cart-error').addClass('on');
            if(cart == 'slide') {
                $('#ajax-cart-form').addClass('contains-alcohol-error');
                $('#ajax-cart-form').find('.form-b').addClass('contains-alcohol-error');
            }
            // disable checkout button
            aac_disable_checkout(form, cart);
        }
    }
}

function aac_form_focus(el, ev, strict) {
    if(strict) {
        if(ev.target !== el) {
            return false;
        }
    }
    var $form = $(el).closest('.aac-cart');
    if($form.find('[data-aac-dob-m]').val() == '') {
        $form.find('[data-aac-dob-m]').focus().select();
    }
    else if($form.find('[data-aac-dob-d]').val() == '') {
        $form.find('[data-aac-dob-d]').focus().select();
    }
    else {
        $form.find('[data-aac-dob-y]').focus().select();
    }
}

function aac_legacy_cart_checkout_button_handler(el) {
    if($('[data-legacy-cart-checkout-button]').prop('disabled')) {
        // focus in DOB form
        aac_form_focus($('.aac-cart.legacy-cart').find('.aac-cart-form').get(0), false, false);
    }
}

function time_min_to_iso_8601(mins) {
    mins = parseInt(mins);
    var days = Math.floor(mins / 1440);
    mins = mins - days * 1440;
    var hours = Math.floor(mins / 60);
    mins = mins - hours * 60;
    var dur = "PT";
    if(days > 0) {
        dur += days + "D";
    }
    if(hours > 0) {
        dur += hours + "H";
    }
    dur += mins + "M"
    return dur;
}

function htmlspecialchars(str) {
    return str
        .replaceAll(/&/g, '&amp;')
        .replaceAll(/"/g, '&quot;')
        .replaceAll(/'/g, '&#039;')
        .replaceAll(/</g, '&lt;')
        .replaceAll(/>/g, '&gt;');
}

function cloudflare_load(videoid, el) {
    $.ajax({
        url: 'https://api.cloudflare.com/client/v4/accounts/9a750c1b972db0bf50025c9927ab831d/stream/' + videoid,
        headers: {
            "Authorization": "Bearer w3ZI8ot1eZz1vR_fwfHTrgsWGJlU7b1GG-ouOCSl"
        }
    })
    .done(res => {
        var aspectratio = res.result.input.height / res.result.input.width * 100;
        $(el).html(`<div style="position: relative; padding-top: ` + aspectratio + `%;"><iframe src="https://iframe.videodelivery.net/` + videoid + `?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fvideodelivery.net%2F` + videoid + `%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe></div>`);
        $(el).addClass('loaded');
        console.log( `[CLOUDFLARE] video loaded: ` + videoid, el );
    })
    .fail(res => {
        $(el).html(`<iframe src="https://iframe.videodelivery.net/` + videoid + `?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fvideodelivery.net%2F` + videoid + `%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=false" style="border: none;" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>`);
        $(el).addClass('error');;
    })
}

// *** MEMBERSHIP QUARTERLY GIFT - ADD TO CART *** //

function cart_mqg_add(btn, cart) {
    if(!$(btn).hasClass('working')) {
        $(btn).addClass('working');
        var data = {
            items: [
                {
                    id: $(btn).data('membership-gift-variant-id'),
                    quantity: 1
                }
            ]
        };
        console.log( `cart_mqg_add() > data`, data );
        $.ajax({
            type: 'POST',
            data: data,
            url: '/cart/add.js',
            dataType: 'json'
        }).done(function(r) {
            // hide quarterly gift add to cart section
            $(btn).closest('.cart-mqg').remove();
            if(cart == 'legacy') {
                // reload page
                location.reload();
            }
        }).fail(function(e) {
            // re-enable atc button
            $(btn).removeClass('working');
        }).always(function() {
        });
    }
}

function product_tile_mobile_swiper(el) {
    var swiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: false
        }
    });
    swiper.on('activeIndexChange', function() {
        if(this.activeIndex % 2 == 0) {
            // even - alt light badge
            el.closest('.ProductItem__Link__Wrapper').classList.add('BadgesAlt');
        }
        else {
            // odd - regular dark badge
            el.closest('.ProductItem__Link__Wrapper').classList.remove('BadgesAlt');
        }
    })
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

const birdhouse_kitchenjournal_fetch = async (url, success, error, always) => {
	try {
		// console.log( `birdhouse_kitchenjournal_fetch()` );
		const r = await fetch('https://birdhouse.flamingoestate.io/' + url);
		const j = await r.json();
		var data = j;
		// console.log( 'data', data );
		// console.log( 'typeof data', typeof data );
		if(
			typeof data !== 'undefined'
		) {
			if(typeof success == 'function') {
				success(data);
			}
		}
		else {
			if(typeof error == 'function') {
				error(data);
			}
		}
		if(typeof always == 'function') {
			always(data);
		}
	}
	catch(e) {
		console.error('XHR failed', e);
	}
}

// ********** //

function birdhouse_kitchenjournal_render_authors_success(data) {
	// console.log( `birdhouse_kitchenjournal_render_authors_success()`, data );
	// console.log( 'this', this );
	jQuery(this).find('[data-dropzone-article-author]').each(function() {
		for(var i = 0; i < data.length; i++) {
			if(jQuery(this).data('dropzone-article-id') == data[i].shopify_id) {
				if(data[i].hasOwnProperty('recipe_author')) {
					if(typeof data[i].recipe_author == 'object') {
						if(data[i].recipe_author.hasOwnProperty('name')) {
							if(data[i].recipe_author.name) {
								// insert recipe author name
								jQuery(this).text(data[i].recipe_author.name);
								// show recipe byline
								jQuery(this).closest('[data-dropzone-article-author-container]').css('display', '');
							}
						}
					}
				}
			}
		}
	});
}

function birdhouse_kitchenjournal_render_authors_error(data) {
	// console.log( `birdhouse_kitchenjournal_render_authors_error()`, data );
	// console.log( 'this', this );
}

function birdhouse_kitchenjournal_render_authors(container) {
	// console.log( `birdhouse_kitchenjournal_render_authors()`, container );
	// console.log( jQuery(container).find('[data-dropzone-article-author-container]') );
	
	var article_ids = [];
	
	jQuery(container).find('[data-dropzone-article-author-container]').each(function() {
		if(jQuery(this).data('dropzone-article-id')) {
			article_ids.push(jQuery(this).data('dropzone-article-id'));
		}
	});
	
	// console.log( 'article_ids', article_ids );
	
	var query_string = '';
	
	for(var i = 0; i < article_ids.length; i++) {
		if(i == 0) {
			query_string += '?';
		}
		else {
			query_string += '&';
		}
		query_string += 'shopify_id=';
		query_string += article_ids[i];
	}
	
	// console.log( 'query_string', query_string );
	
	var query_url = 'recipes' + query_string;
	
	// console.log( 'query_url', query_url );
	
	birdhouse_kitchenjournal_fetch(query_url, birdhouse_kitchenjournal_render_authors_success.bind(container), birdhouse_kitchenjournal_render_authors_error.bind(container));
	
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function birdhouse_format_time(input) {
	var mins = parseInt(input);
	if(!isNaN(mins) && mins > 0) {
		if(mins > 60) {
			var hrs = mins / 60;
			hrs = Math.floor(hrs);
			var output = hrs + ' ';
			output += (hrs == 1) ? 'hour' : 'hours';
			mins = Math.round(mins / 60 % 1 * 60);
			if(mins > 0) {
				output += ' ';
				output += mins + ' ';
				output += (mins == 1) ? 'minute' : 'minutes';
			}
		}
		else {
			var output = mins + ' ';
			output += (mins == 1) ? 'minute' : 'minutes';
		}
		return output;
	}
	else {
		return false;
	}
}

function birdhouse_featured_recipes_render(r) {
	// console.log( `birdhouse_featured_recipes_render(r)`, r );
	// AUTHOR
	var author_valid = false;
	if(r.hasOwnProperty('recipe_author')) {
		if(r.recipe_author.hasOwnProperty('name')) {
			author_valid = true;
		}
	}
	// if author is present
	if(author_valid) {
		// set author
		jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-author]').html(r.recipe_author.name);
	}
	// if author is not present
	else {
		// remove byline
		jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('.featured-recipes-carousel-item-byline').remove();
	}
	// ATTRS
	var occasion_valid = false;
	if(r.hasOwnProperty('recipe_occasions')) {
		if(r.recipe_occasions.length > 0) {
			occasion_valid = true;
		}
	}
	var cooktime_valid = false;
	if(r.hasOwnProperty('time_cook')) {
		if(r.time_cook) {
			cooktime_valid = true;
		}
	}
	if(occasion_valid || cooktime_valid) {
		// OCCASION
		if(occasion_valid) {
			// set occasion
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-occassion]').html(r.recipe_occasions[0].name);
		}
		else {
			// remove occasion attr
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-occassion]').parent().remove();
		}
		// COOK TIME
		if(cooktime_valid) {
			// set cook time
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-cooktime]').html(birdhouse_format_time(r.time_cook));
		}
		else {
			// remove cook time attr
			jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('[data-dropzone-cooktime]').parent().remove();
		}
	}
	else {
		// remove attrs
		jQuery('[data-dropzone-articleid="' + r.shopify_id + '"]').find('.featured-recipes-carousel-item-attrs').html('');
	}
}

function birdhouse_featured_recipes(ids) {
	// console.log( `birdhouse_featured_recipes(ids)`, ids );
	// build query
	var query = '?';
	ids.forEach(function(id, i) {
		if(i != 0) {
			query += '&';
		}
		query += 'shopify_id=' + id;
	});
	// console.log( `query`, query );
	// API call
	jQuery.ajax({
		type: 'GET',
		url: 'https://birdhouse.flamingoestate.io/recipes' + query
	}).done(function(r, textStatus, jqXHR) {
		console.log( 'Birdhouse API call successful', r );
		// console.log( 'textStatus', textStatus );
		// console.log( 'jqXHR', jqXHR );
		r.forEach(function(data) {
			birdhouse_featured_recipes_render(data);
		});
	}).fail(function(e) {
		console.warn( 'Birdhouse API call failure', e );
		var res = JSON.parse(e.responseText);
		console.log( res );
		ids.forEach(function(id) {
			// remove byline
			jQuery('[data-dropzone-articleid="' + id + '"]').find('.featured-recipes-carousel-item-byline').remove();
			// remove attrs
			jQuery('[data-dropzone-articleid="' + id + '"]').find('.featured-recipes-carousel-item-attrs').html('');
		});
	});
}

// **************************************************************** //
// FLAMINGO ESTATE
// MEGA MENU V3
// **************************************************************** //

$(function() {
    // Menu functions
    function megamenu_v3_menu_open() {
        if(!$('body').hasClass('megamenu-v3-menu-open')) {
            $('.megamenu-v3-menu-card-content').scrollTop(0);
            $('body').addClass('megamenu-v3-menu-open');
            megamenu_v3_search_close();
        }
    }

    function megamenu_v3_menu_close() {
        if($('body').hasClass('megamenu-v3-menu-open')) {
            $('body').removeClass('megamenu-v3-menu-open');
        }
    }

    function megamenu_v3_menu_toggle() {
        if(!$('body').hasClass('megamenu-v3-menu-open')) {
            megamenu_v3_menu_open();
        }
        else {
            megamenu_v3_menu_close();
        }
    }

    $('[data-megamenu-v3-menu-open]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_menu_open();
    });

    $('[data-megamenu-v3-menu-close]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_menu_close();
    });

    $('[data-megamenu-v3-menu-toggle]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_menu_toggle();
    });

    // Search functions
    function megamenu_v3_search_open() {
        if(!$('body').hasClass('megamenu-v3-search-open')) {
            $('body').addClass('megamenu-v3-search-open');
            $('#megamenu-v3-search-field').focus();
            $('#megamenu-v3-search-field').select();
        }
    }

    function megamenu_v3_search_close() {
        if($('body').hasClass('megamenu-v3-search-open')) {
            $('body').removeClass('megamenu-v3-search-open');
        }
    }

    function megamenu_v3_search_toggle() {
        if(!$('body').hasClass('megamenu-v3-search-open')) {
            megamenu_v3_search_open();
        }
        else {
            megamenu_v3_search_close();
        }
    }

    $('[data-megamenu-v3-search-open]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_search_open();
    });

    $('[data-megamenu-v3-search-close]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_search_close();
    });

    $('[data-megamenu-v3-search-toggle]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_search_toggle();
    });

    // Projects functions
    function megamenu_v3_projects_open() {
        if(!$('body').hasClass('megamenu-v3-projects-open')) {
            $('body').addClass('megamenu-v3-projects-open');
        }
    }

    function megamenu_v3_projects_close() {
        if($('body').hasClass('megamenu-v3-projects-open')) {
            $('body').removeClass('megamenu-v3-projects-open');
        }
    }

    function megamenu_v3_projects_toggle() {
        if(!$('body').hasClass('megamenu-v3-projects-open')) {
            megamenu_v3_projects_open();
        }
        else {
            megamenu_v3_projects_close();
        }
    }

    $('[data-megamenu-v3-projects-toggle]').on('click', function(e) {
        e.preventDefault();
        megamenu_v3_projects_toggle();
    });

    // Shop submenu accordion
    $(".shop-submenu-toggle").click(function() {
        if($(this).hasClass('active')) {
            let this_index = $(this).parent().index();
            $(this).parent().parent().children().each(function(i) {
                if(i != this_index) {
                    if(!$(this).find('.shop-submenu-toggle').hasClass('active')) {
                        $(this).find('.shop-menu-dropdown').slideUp('normal');
                        $(this).find('.shop-submenu-toggle').addClass('active');
                    }
                }
            });
            $(this).next('.shop-menu-dropdown').slideDown('normal');
            $(this).removeClass('active');
        }
        else {
            $(this).next('.shop-menu-dropdown').slideUp('normal');
            $(this).addClass('active');
        }
    });
});